export enum ToolName {
  monomer = 'monomer',
  preset = 'preset',
  selectRectangle = 'select-rectangle',
  bondSingle = 'bond-single',
  bondHydrogen = 'bond-hydrogen',
  erase = 'erase',
  clear = 'clear',
  hand = 'hand',
}

export enum MACROMOLECULES_BOND_TYPES {
  SINGLE = 'single',
  HYDROGEN = 'hydrogen',
}
